import { useEffect, useState } from "react";

// Interfaces
import { IPartnerPeriodsChecksProps } from "./interfaces";

// MUI
import { Checkbox, Divider, FormControlLabel, Grid, Stack } from "@mui/material";

export default function PartnerPeriodsChecks(props: Readonly<IPartnerPeriodsChecksProps>) {
	const { selections = [], payPeriodParts = [], isDisabled = false, onChangeAction = () => {} } = props;
	const [innerSelection, setInnerSelection] = useState<string[]>([]);

	const isShowed = Boolean(payPeriodParts.length);

	const handleOnChange = (ccId = "") => {
		const updated = [...new Set([...innerSelection, ccId])];
		setInnerSelection(updated);
		onChangeAction(ccId);
	};

	useEffect(() => {
		setInnerSelection(selections);
		return () => {
			setInnerSelection([]);
		};
	}, [selections]);

	if (!isShowed) {
		return null;
	}

	return (
		<Stack width={1}>
			<Grid item sx={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
				{payPeriodParts.map((part, key) => (
					<FormControlLabel
						key={`${part.ccId}_${key}`}
						control={
							<Checkbox
								checked={innerSelection.includes(part?.ccId ?? "")}
								onChange={() => handleOnChange(part?.ccId)}
								disabled={isDisabled}
							/>
						}
						label={part.label}
						labelPlacement="end"
						className="group-pay-plan-assign-container-select-all"
					/>
				))}
			</Grid>
			<Divider sx={{ margin: "10px 0" }} />
		</Stack>
	);
}
